import { render, staticRenderFns } from "./domSmallCard.vue?vue&type=template&id=16625612&scoped=true&"
import script from "./domSmallCard.vue?vue&type=script&lang=js&"
export * from "./domSmallCard.vue?vue&type=script&lang=js&"
import style0 from "./domSmallCard.vue?vue&type=style&index=0&id=16625612&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16625612",
  null
  
)

export default component.exports